export const ACCEPT = 'accept'
export const RESET = 'reset'
export const NAME = 'name'
export const INSTALLATION_TYPES = 'installationTypes'
export const GEOZONE = 'geoZone'
export const PROJECT = 'project'
export const INTEGRATION_IDS = 'integrationIds'
export const REGION = 'region'
export const CITY = 'city'